export default {
      id: "ic_share_black-usage",
      viewBox: "0 0 16 18",
      url: "/" + "images/icons.3.109.2.svg#ic_share_black-usage",
      toString: function () {
        return this.url;
      }
    }